import { createSlice } from '@reduxjs/toolkit';
import type { WorkOrdersSquare } from 'types/squares.type';
import type {
  AssetsReliabilityData,
  ComponentReliabilityData,
  DownTimeAssetDetails,
  IdlingEvent,
} from 'views/SurvivalAnalysis/Reliability/types';

export interface OverviewState {
  assets: AssetsReliabilityData[];
  components: ComponentReliabilityData[];
  workOrders: WorkOrdersSquare[];
  assetsWithDownTime: DownTimeAssetDetails[];
  idlingData: IdlingEvent[];
  isLoadingReliability: boolean;
}

const initialState: OverviewState = {
  assets: [],
  components: [],
  workOrders: [],
  assetsWithDownTime: [],
  idlingData: [],
  isLoadingReliability: false,
};

export const reliabilitySlice = createSlice({
  name: 'reliabilitySlice',
  initialState,
  reducers: {
    appendData(state, { payload }) {
      state.components = payload.components;
      state.assets = payload.assets;
      state.workOrders = payload.workOrders;
      state.assetsWithDownTime = payload.withDownTime;
      state.idlingData = payload.idlingData;
    },
    setIsLoadingReliability(state, { payload }) {
      state.isLoadingReliability = payload;
    },
  },
});

export const { appendData, setIsLoadingReliability } = reliabilitySlice.actions;

export const ReliabilitySlice = createSlice({
  name: 'reliabilitySlice',
  initialState,
  reducers: {},
});

export default reliabilitySlice.reducer;
